
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1965"}},[_c('path',{attrs:{"data-name":"Rectangle 2696","fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"data-name":"Group 1964"}},[_c('g',{attrs:{"data-name":"Group 1962"}},[_c('path',{attrs:{"data-name":"Path 1286","d":"M2.433 23a2.442 2.442 0 01-1.308-.243.242.242 0 01-.126-.251C.999 20.441 7.228 15 12.208 15c4.914 0 10.791 5.323 10.791 7.419a.324.324 0 01-.153.32 2.469 2.469 0 01-1.355.261z","fill":"#f9a36c"}}),_c('path',{attrs:{"data-name":"Path 1287","d":"M12.208 16c4.062 0 8.854 4.1 9.671 5.983a4.11 4.11 0 01-.388.017H2.433c-.094 0-.178 0-.252-.007C3.191 20.052 8.146 16 12.208 16m0-2C5.17 14-4.606 24 2.433 24h19.058c7.036 0-2.244-10-9.283-10z"}})]),_c('g',{attrs:{"data-name":"Group 1963","transform":"translate(-280.457 -307.174)"}},[_c('circle',{attrs:{"data-name":"Ellipse 250","cx":"5","cy":"5","r":"5","transform":"translate(287.456 309.174)","fill":"#f9a36c"}}),_c('path',{attrs:{"data-name":"Path 1288","d":"M292.456 310.174a4 4 0 11-4 4 4.005 4.005 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6z"}})])])])])
          )
        }
      }
    